import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0f172a]/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-cyan-500/20 group-hover:scale-110 transition">
            <span className="font-black text-xl text-white">N</span>
          </div>
          <span className="text-xl font-bold tracking-tight text-white">neohost<span className="text-cyan-500">.pl</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-400">
          <Link to="/" className="hover:text-white transition">Strona Główna</Link>
          <a href="/#features" className="hover:text-white transition">Funkcje</a>
          <a href="/#pricing" className="hover:text-white transition">Cennik</a>
        </div>

        <div className="flex items-center gap-4">
          <Link to="/login" className="bg-cyan-500 hover:bg-cyan-400 px-6 py-2.5 rounded-full font-bold text-sm transition shadow-lg shadow-cyan-500/20 text-white">
            Panel Klienta
          </Link>
        </div>
      </div>
    </nav>
  );
};

// TEJ LINII BRAKOWAŁO:
export default Navbar;